import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TestComponent } from './test.component';
import { SharedModule } from '../../shared/shared.module';
import { TestService } from './test.service';
import { TestRoutingModule } from './test-routing.module';

@NgModule({
    declarations: [
        TestComponent,
    ],
    imports: [
        CommonModule,
        SharedModule,
        TestRoutingModule,
    ],
    providers: [
        TestService,
    ]
})
export class TestModule {}
